import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import GlobalCursor from '../components/GlobalCursor'

export default function NotFound() {
  return (
    <div className="min-h-screen relative overflow-hidden bg-black">
      <GlobalCursor />
      <div className="absolute inset-0 stars"></div>
      <div className="absolute inset-0 stars2"></div>

      <div className="relative z-20 px-4 sm:px-6 py-6 sm:py-8 max-w-6xl mx-auto pt-24 sm:pt-32 md:pt-40 text-center">
        <motion.h1
          className="text-7xl sm:text-8xl md:text-9xl font-bold text-white mb-8"
          style={{
            fontFamily: "'Clash Display', 'Arial Black', sans-serif",
            fontWeight: 700,
            letterSpacing: '-0.01em',
            lineHeight: '0.7',
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.2,
            ease: 'easeOut',
          }}
        >
          404
          <br />
          not found
        </motion.h1>

        <div className="text-white max-w-4xl mx-auto mb-8">
          <p className="text-xl mb-8">
            The page you're looking for doesn't exist.
          </p>
          <Link
            to="/"
            className="inline-block px-8 py-4 bg-[#E06100] text-white font-medium rounded-xl hover:bg-[#C55000] transition-colors duration-300"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  )
}